<template>
  <v-app
    id="app"
    dark
  >
    <router-view></router-view>
    <v-snackbar
      top
      right
      error
      :timeout="errorTimeout"
      v-model="error.active"
    >
      {{ error.text }}
    </v-snackbar>
    <v-snackbar
      top
      right
      primary
      :timeout="messageTimeout"
      v-model="message.active"
    >
      {{ message.text }}
    </v-snackbar>
  </v-app>
</template>

<script>
/**
 * Fornisce la route-view principale
 * e istanzia i componenti per visualizzare i messaggi
 * @module components/App 
 */
import utils from '@/utils'
export default {
  name: 'app',
  data () {
    return {
      errorTimeout: utils.TOAST_ERR_TIMEOUT,
      messageTimeout: utils.TOAST_MSG_TIMEOUT,
      error: {active: false, text: ''},
      message: {active: false, text: ''}
    }
  },
  watch: {
    errorState (response) {
      if(response === null)
        return

      if(response.msg.status === 0){
        this.error = {active: true, text: 'Errore di connessione'}
      }else{
        this.error = {active: true, text: response.msg.body}
      }

      let that = this;
      setTimeout(() => {
        that.error = {active: false, text: ''}
      }, this.errorTimeout)
    },
    messageState (message) {
      if(message === null)
        return

      this.message = {active: true, text: message.msg}

      let that = this;
      setTimeout(() => {
        that.message = {active: false, text: ''}
      }, this.messageTimeout)
    }
  },
  computed: {
    errorState () {
        return this.$store.getters.lastError
    },
    messageState () {
        return this.$store.getters.lastMessage
    }
  }
}
</script>

<style lang="stylus">
  @import '../stylus/main'
</style>
  




// WEBPACK FOOTER //
// src/components/App.vue